import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./MentionsLegalesPage.module.scss"; // Make sure you have a corresponding SCSS file

import Footer from '../../components/Footer/Footer';

const MentionsLegalesPage_En = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <h1>Legal notice</h1>

        <hr />
        <section>
          <h2>1. Website / Application Publisher</h2>
          <p><strong>Company or Publisher Name:</strong> Hatanna Éditions (Micro), represented by Mrs. Célia Barbier.</p>
          <p><strong>Head Office:</strong> 173 Bd National 84400 APT</p>
          <p><strong>Registration Number (SIREN):</strong> 832486237</p>
          <p><strong>Contact Email:</strong> <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a></p>
        </section>

        <section>
          <h2>2. Hosting</h2>
          <p><strong>Hosting Provider Name:</strong> OVH RCS Roubaix – Tourcoing 424 761 419 00045 Code APE 6202A</p>
          <p><strong>Address:</strong> 2 rue Kellermann - 59100 Roubaix - France</p>
        </section>

        <section>
          <h2>3. Intellectual property</h2>
          <p>
            All content present in the application (texts, images, videos, source codes, design, logo...)
            is protected by intellectual property law. Any reproduction, distribution, or modification
            without prior authorization is prohibited and may result in legal action.
          </p>
        </section>

        <section>
          <h2>4. Personal data and privacy</h2>
          <p>
            The data collected through the application is processed in accordance with our
            <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer"> privacy policy</a>.
            In accordance with the <strong>General Data Protection Regulation (GDPR)</strong>, you have the right
            to access, correct, and delete your personal data by contacting us at: [Contact Email].
          </p>
        </section>

        <section>
          <h2>5. Liability</h2>
          <p>
            The publisher of the application cannot be held responsible for:
          </p>
          <ul>
            <li>Temporary service interruptions due to maintenance operations.</li>
            <li>Errors or omissions in the displayed content.</li>
            <li>Damages related to the use of the application by the user.</li>
          </ul>
        </section>

        <section>
          <h2>6. Hyperlinks</h2>
          <p>
            The application may contain links to third-party websites. The publisher declines any responsibility
            for the content of these websites and any potential consequences of their use.
          </p>
        </section>

        <section>
          <h2>7. Applicable law</h2>
          <p>
            This legal notice is governed by French law (or another applicable jurisdiction based on your country).
            In case of dispute, the competent courts will be those of the publisher's head office.
          </p>
        </section>

        <section>
          <h2>8. Development</h2>
          <p>
            This application was developed by <strong>Scriptales SAS</strong>
            (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">https://scriptales.fr</a>).
          </p>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default MentionsLegalesPage_En;
